export const CONTACT_PHONE = '88007073902';

export const CONTACT_EMAIL = 'support.cpa@sravni.ru';
